import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../../../services/store';
import { getSelectedPostTypeFilter } from 'src/shared/redux-state/src';
import { CustomCheckbox } from 'src/app/components';

const filterByTypeData = [
  {
    name: 'Posts',
    id: 'POSTS',
  },
  {
    name: 'Polls',
    id: 'POLL',
  },
  {
    name: 'Posts with Confirmation',
    id: 'CONFIRMATION_POSTS',
  },
];
type EngageFilterHeaderProps = {
  saveFilterTypeSelection: (types: string[]) => void;
  orgPostFilterType: Array<string> | null
};

const EngageFilterBody: React.FC<EngageFilterHeaderProps> = ({ saveFilterTypeSelection,
   orgPostFilterType }) => {
  const selectedFilterTypes: string[] = useAppSelector(getSelectedPostTypeFilter);
  const [selectedTypes, setSelectedTypes] = useState(selectedFilterTypes || []);

  useEffect(() => {
    orgPostFilterType && setSelectedTypes(orgPostFilterType);
  }, [orgPostFilterType]);

  useEffect(() => {
    saveFilterTypeSelection(selectedTypes);
  }, [saveFilterTypeSelection, selectedTypes]);

  const handleItemPress = (item: any) => {
    const currItemId = selectedTypes.find((id: string) => id === item?.id);
    if (currItemId) {
      const filteredRes = selectedTypes.filter((id: string) => id !== item?.id);
      setSelectedTypes(filteredRes);
    } else {
      setSelectedTypes((arr: string[]) => [...arr, item?.id]);
    }
  };


  const renderFilterByTypeCard = ({ item }: any) => {
    const isSelected = selectedTypes.includes(item?.id);

    return (
      // <div onClick={() => handleItemPress(item)}>
      //   <input type="checkbox" id={item.id} name={item.id}
      //     value={item.id} checked={isSelected} />
      //   <label htmlFor={item.id}> {item?.name}</label>
      // </div>
      <div className='mg-t-8'>
        <CustomCheckbox 
          label={item?.name} 
          isChecked={isSelected} 
          onChange={() => handleItemPress(item)} 
        />
      </div>
    );
  };

  return (
    <>
      <div className='fs-14 fw-semibold text-black mg-b-10'>Filter By:</div>
      {
        filterByTypeData.map(item => (
          <div>{
            renderFilterByTypeCard({ item })
          }</div>
        ))
      }
    </>
  );
};

export default EngageFilterBody;
